import AxiosService from './AxiosService';
import { snakeToCamelCaseKeys, camelToSnakeCaseKeys } from './helpers';

class PerformAction {
  constructor() {
    if (!PerformAction.instance) {
      PerformAction.instance = this;
    }
    return PerformAction.instance;
  }

  objectEndpoint = 'custom-objects';

  getSummaryEndpoint = 'bulk-actions/summary';
  getCustomSummaryEndpoint = 'bulk-actions/custom/summary';

  getSummaryCOEndpoint = (objectId) =>
    `/${this.objectEndpoint}/${objectId}/bulk-action-summary`;

  changeTagsEndpoint = '/client/bulk_change_tags';

  manageTeamEndpoint = '/client/bulk_associate_team_member';

  getManageTeamCOEndpoint = (objectId) =>
    `/${this.objectEndpoint}/${objectId}/bulk-assign-team-members`;

  manageSubscriptionsEndpoint = 'client/bulk-manage-subscriptions';

  exportEndpoint = '/client/export-contacts';

  getExportCOEndpoint = (objectId) =>
    `/${this.objectEndpoint}/${objectId}/export-entity-records`;

  archiveEndpoint = '/client/bulk_destroy';

  getArchiveCOEndpoint = (objectId) =>
    `/${this.objectEndpoint}/${objectId}/bulk-archive-entity-record`;

  changeFieldValueEndpoint = '/client/bulk-change-field-value';

  getChangeFieldValueCOEndpoint = (objectId) =>
    `/${this.objectEndpoint}/${objectId}/bulk-change-field-value`;

  surveyEndpoint = '/survey/';

  clientEndpoint = '/client';

  automationCOEndpoint = (objectId, action = 'start') =>
    `/${this.objectEndpoint}/${objectId}/bulk-${action}-automation`;

  customActionCOEndpoint = (objectId) =>
    `/${this.objectEndpoint}/${objectId}/bulk-custom-action`;

  sendEmail = async ({ emailId, clientKey }) => {
    const { data } = await AxiosService.post(`email-template/${emailId}/send`, {
      client_key: clientKey,
    });
    return data;
  };
  //Email by Template
  sendEmailTemplate = async (payload) => {
    const { data } = await AxiosService.post(`${this.clientEndpoint}/message`, {
      ...payload,
    });
    return data;
  };

  async modifyAutomation({ objectId, action, ...rest }) {
    const payload = camelToSnakeCaseKeys(rest);
    const { data } = await AxiosService.post(
      this.automationCOEndpoint(objectId, action),
      payload
    );
    return data;
  }

  async performCustomAction(payload) {
    const { data } = await AxiosService.post(
      '/bulk-actions/custom/process',
      payload
    );
    return data;
  }

  async saveSendSurvey({ clientKey, id, sendEmailNotification }) {
    const { data } = await AxiosService.post(
      `${this.surveyEndpoint}${id}/send_request`,
      {
        client_key: clientKey,
        id,
        send_email_notification: sendEmailNotification
      }
    );
    return data;
  }

  async changeTags(tagsData) {
    const { data } = await AxiosService.post(
      `${this.changeTagsEndpoint}?v2=true`,
      camelToSnakeCaseKeys(tagsData)
    );
    return data;
  }

  async manageTeam({ objectId, ...rest }) {
    const payload = camelToSnakeCaseKeys(rest);
    const { data } = await AxiosService.post(
      objectId
        ? this.getManageTeamCOEndpoint(objectId)
        : `${this.manageTeamEndpoint}?v2=true`,
      payload
    );
    return data;
  }

  async manageSubscriptions({ clientKey, subscriptionListId, status, sendEmailNotification }) {
    const { data } = await AxiosService.post(
      `${this.manageSubscriptionsEndpoint}?v2=true`,
      camelToSnakeCaseKeys({
        clientKey,
        subscriptionListId,
        status,
        sendEmailNotification
      })
    );
    return data;
  }

  async exportRecords({ objectId, ...rest }) {
    const payload = camelToSnakeCaseKeys(rest);
    const { data } = await AxiosService.post(
      objectId ? this.getExportCOEndpoint(objectId) : this.exportEndpoint,
      payload
    );
    return snakeToCamelCaseKeys(data);
  }

  async archiveRecords({ objectId, ...rest }) {
    const payload = camelToSnakeCaseKeys(rest);
    const { data } = await AxiosService.post(
      objectId
        ? this.getArchiveCOEndpoint(objectId)
        : `${this.archiveEndpoint}?v2=true`,
      payload
    );
    return snakeToCamelCaseKeys(data);
  }

  async startSummary(body, options) {
    const { data } = await AxiosService.post(
      body.custom_action_id
        ? this.getCustomSummaryEndpoint
        : this.getSummaryEndpoint,
      body,
      options
    );
    return data;
  }

  async getSummary(summaryId, options) {
    const { data } = await AxiosService.get(
      `${this.getSummaryEndpoint}/${summaryId}`,
      options
    );
    return data;
  }

  async changeFieldValue({ objectId, ...rest }) {
    const payload = camelToSnakeCaseKeys(rest);
    const { data } = await AxiosService.post(
      objectId
        ? this.getChangeFieldValueCOEndpoint(objectId)
        : this.changeFieldValueEndpoint,
      payload
    );
    return snakeToCamelCaseKeys(data);
  }

  getBulkActionProgress = async (params, options) => {
    const { data } = await AxiosService.get('bulk-action-progress', {
      ...options,
      params,
    });
    return data;
  };

  getBulkActionProgressById = async (executionId, options) => {
    const { data } = await AxiosService.get(
      `bulk-action-progress/${executionId}`,
      options
    );
    return data;
  };
}

const instance = new PerformAction();
Object.freeze(instance);

export default instance;
